import { unescape } from 'html-escaper';
import { FileModel, ToolCustomerArtworkCategoryModel, UserModel } from '.';
import { SYSTEM_LANGUAGES } from '../actions/variables';
import { translate } from '../helpers/frontend';

/*
  channel : String
    - C2U
    - Store Code

  status : Number
    0 = Inactive
    1 = Active
*/

export class ToolCustomerArtworkModel {
  constructor(data={}) {
    this._id = data?._id || null;
    
    this.category = new ToolCustomerArtworkCategoryModel(data.category || {});

    this.name = data.name? unescape(data.name): null;
    this.description = data.description? unescape(data.description): null;

    this.url = data.url || null;
    this.image = new FileModel(data.image || {});

    this.editorImage = new FileModel(data.editorImage || {});
    this.editors = this.cleanEditors(data.editors || []);

    this.content = data.content? unescape(data.content): null;
    
    this.order = data.order? Number(data.order): 1;
    this.status = data.status? Number(data.status): 0;

    this.createdBy = new UserModel(data.createdBy || {});
    this.createdAt = data.createdAt || null;
    this.updatedBy = new UserModel(data.updatedBy || {});
    this.updatedAt = data.updatedAt || null;

    // Localization
    this.localization(data);
  }
  localization(data){
    let self = this;
    self.localizedKeys = [ 'name', 'description', 'content' ];
    SYSTEM_LANGUAGES.forEach(lang => {
      self.localizedKeys.forEach(k => {
        let key = `${k}${lang}`;
        self[key] = data[key]? unescape(data[key]): data[k];
      });
    });
  }

  isValid() { return this._id? true: false; }

  cleanEditor(d={}) {
    return {
      type: d?.type || 'Text',
      posX: d?.posX || 0,
      posY: d?.posY || 0,
      rotate: d?.rotate || 0,
      opacity: d?.opacity || 1,
      text: d?.text || '',
      textFamily: d?.textFamily || 'Kanit, sans-serif',
      textSize: d?.textSize || 16,
      textColor: d?.textColor || '#000000',
      textAlign: d?.textAlign || 'left',
      textWeight: d?.textWeight || false,
      textStyle : d?.textStyle || 'normal',
      lineHeight : d.lineHeight || 1.4,
      textUnderline: d?.textUnderline || 0,
      textBackground: d?.textBackground || '',
      paddingX : d?.paddingX || 0,
      paddingY : d?.paddingY || 0,
    };
  }
  cleanEditors(editors=[]) {
    if(!Array.isArray(editors)) return [];
    return editors.map(d => {
      if(['Text'].indexOf(d.type) < 0) return null;
      return this.cleanEditor(d);
    }).filter(d => d);
  }
  initEditor(type='Text', d={}) {
    return this.cleanEditor({ ...d, type: type });
  }

  displayStatus(langObj={}) {
    if(this.isValid()){
      if(this.status === 1) return (<span className="ss-tag bg-success">{translate('Active',langObj)}</span>);
      return (<span className="ss-tag bg-fgray color-dark">{translate('Inactive',langObj)}</span>);
    }
    return (<></>);
  }
}